import {
  pluginSettingListGet,
  pluginSettingPatch,
  configGet
} from '../utils/PluginAPI/PluginAPI';
import {
  notificationAddSuccess,
  notificationAddClientAPIError,
  notificationAddError
} from './notifications';
import * as ActionTypes from '../constants/ActionTypes';
import { asyncIntlFetchTranslations } from './intl';
import { isLoggedIn, getEmail } from '../utils/Auth/Auth';
import { asyncUserLoginSuccess } from '../actions/user';
import { ABSOLUTE_URL_BASE_KEY } from '../reducers/config';

export function pluginFetchSettings() {
  return {
    type: ActionTypes.PLUGIN_SETTINGS_FETCH
  };
}

export function pluginFetchSettingsSuccess(zoneId, setting) {
  return {
    type: ActionTypes.PLUGIN_SETTINGS_FETCH_SUCCESS,
    zoneId,
    setting
  };
}

export function pluginFetchSettingsError() {
  return {
    type: ActionTypes.PLUGIN_SETTINGS_FETCH_ERROR
  };
}

export function pluginUpdateSetting(zoneId, setting) {
  return {
    type: ActionTypes.PLUGIN_SETTING_UPDATE,
    zoneId,
    setting
  };
}

export function pluginUpdateSettingSuccess(zoneId, setting) {
  return {
    type: ActionTypes.PLUGIN_SETTING_UPDATE_SUCCESS,
    zoneId,
    setting
  };
}

export function pluginUpdateSettingError(zoneId, setting) {
  return {
    type: ActionTypes.PLUGIN_SETTING_UPDATE_ERROR,
    zoneId,
    setting
  };
}

export function asyncPluginFetchSettings(zoneId) {
  return dispatch => {
    dispatch(pluginFetchSettings());
    pluginSettingListGet({ zoneId: zoneId }, function(error, response) {
      if (response) {
        dispatch(pluginFetchSettingsSuccess(zoneId, response.body.result));
      } else {
        dispatch(
          notificationAddClientAPIError(pluginFetchSettingsError(), error)
        );
      }
    });
  };
}

export function asyncPluginUpdateSetting(settingName, zoneId, value) {
  return (dispatch, getState) => {
    let oldSetting = getState().pluginSettings.entities[zoneId][settingName];

    dispatch(pluginUpdateSetting(zoneId, { id: settingName, value: value }));
    pluginSettingPatch(zoneId, settingName, value, function(error, response) {
      if (response) {
        dispatch(pluginUpdateSettingSuccess(zoneId, response.body.result));

        if (settingName == 'default_settings') {
          dispatch(
            notificationAddSuccess(
              'container.applydefaultsettingscard.success',
              true
            )
          );
        }
      } else {
        dispatch(
          notificationAddClientAPIError(
            pluginUpdateSettingError(zoneId, oldSetting),
            error
          )
        );
      }
    });
  };
}

export function configFetch() {
  return {
    type: ActionTypes.CONFIG_FETCH
  };
}

export function configFetchSuccess() {
  return {
    type: ActionTypes.CONFIG_FETCH_SUCCESS
  };
}

export function configFetchError() {
  return {
    type: ActionTypes.CONFIG_FETCH_ERROR
  };
}

export function asyncConfigInit() {
  return dispatch => {
    /*
     * 1. Fetch config.js
     * 2. Fetch userConfig.js (which may not exist)
     * 3. Fetch translations with the language from the config. 
     */
    dispatch(asyncConfigFetch());
    if (typeof window.absoluteUrlBase !== 'undefined') {
      /*
       * Some integrations don't work with relative paths because the URL doesn't match
       * the actual file path, this function allows integrations to configure a base absolute
       * url path to be used in components/Image. absoluteBaseUrl should be defined globally
       * on the page where the SPA is loaded.
       */
      dispatch(
        configUpdateByKey(ABSOLUTE_URL_BASE_KEY, window.absoluteUrlBase)
      );
    }
    //log user in if their email is in local storage
    if (isLoggedIn()) {
      dispatch(asyncUserLoginSuccess(getEmail()));
    }
  };
}

export function asyncConfigFetch() {
  return dispatch => {
    dispatch(configFetch());
    configGet(function(error, response) {
      if (response) {
        dispatch(configFetchSuccess());
        try {
          let userConfig = JSON.parse(response.text).result;
          Object.keys(userConfig).map(function(key) {
            dispatch(configUpdateByKey(key, userConfig[key]));
          });
        } catch (e) {
          dispatch(notificationAddError(`/config - ${e.message}`));
        }
        dispatch(asyncIntlFetchTranslations());
      } else {
        dispatch(configFetchError());
      }
    });
  };
}

export function configUpdateByKey(key, value) {
  return {
    type: ActionTypes.CONFIG_UPDATE_BY_KEY,
    key,
    value
  };
}



// WEBPACK FOOTER //
// src/actions/pluginSettings.js